import React from 'react';
import { Box, MenuItem, Select, FormControl, InputLabel, Button } from '@mui/material';
import SearchBar from '../../sections/@dashboard/SearchBar';
import DateRangeFilter from '../DateRangeFilter';
import { LightTooltip } from '../custom-components/custom-tooltip';

export default function EmailFilters({
  searchTerm,
  onSearch,
  statusFilter,
  onStatusFilterChange,
  uniqueStatuses,
  startDate,
  endDate,
  datePreset,
  onDateRangeChange,
  onClearFilters,
}) {
  const [statusOpen, setStatusOpen] = React.useState(false);
  const [dateOpen, setDateOpen] = React.useState(false);

  return (
    <Box marginBottom={2} display="flex" flexWrap="wrap" alignItems="center" gap={2}>
      <SearchBar onSearch={onSearch} value={searchTerm} />
      <Box width={250} flexShrink={0}>
        <LightTooltip title="Filter emails by their current delivery status." disableHoverListener={statusOpen || dateOpen}>
          <FormControl fullWidth>
            <InputLabel id="status-filter-label">Status</InputLabel>
            <Select
              labelId="status-filter-label"
              value={statusFilter}
              onChange={onStatusFilterChange}
              label="Status"
              onOpen={() => setStatusOpen(true)}
              onClose={() => setStatusOpen(false)}
            >
              <MenuItem value="all">All Statuses</MenuItem>
              {uniqueStatuses.map((status) => (
                <MenuItem key={status} value={status}>
                  {status}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </LightTooltip>
      </Box>
      <Box display="flex" alignItems="center" gap={2} flexShrink={0} sx={{ minWidth: 320 }}>
        <LightTooltip title="Filter emails within a specific date range." disableHoverListener={statusOpen || dateOpen}>
          <Box sx={{ flexGrow: 1 }}>
            <DateRangeFilter
              onDateRangeChange={onDateRangeChange}
              startDate={startDate}
              endDate={endDate}
              selectedPreset={datePreset}
              sx={{ height: '55px' }}
              onOpen={() => setDateOpen(true)}
              onClose={() => setDateOpen(false)}
            />
          </Box>
        </LightTooltip>
        <Button variant="outlined" onClick={onClearFilters} sx={{ height: '55px' }}>
          Clear Filters
        </Button>
      </Box>
    </Box>
  );
}
